export const APPROVE_ACTION = 'APPROVED';
export const REJECTE_ACTION = 'REJECTED';

export const EDITABLE = 'EDITABLE';
